export enum ArticleType {
    article = 0,
    service = 1,
    support = 2
}